import React from 'react'
import { PopType } from '../../types'
import { PopFormDefault } from './PopFormDefault'
import { RePOPForm } from './RePOPForm'
import { PopGPT } from './PopGPT'
import { FakeRePop } from './FakeRePop'
import { AIPop } from './AIPop'
import { AIRepopForm } from './AIRepop'
import { ActionPopForm } from './ActionPopForm'

export const renderFormByType = (type: number, isEdit: boolean) => {
  switch (type) {
    case PopType.Default:
      return <PopFormDefault />
    case PopType.LinkPop:
      return <PopFormDefault isLinkPop />
    case PopType.RePop:
      return <RePOPForm isEdit={isEdit} />
    case PopType.ChatGpt:
      return <PopGPT />
    case PopType.FakeRe:
      return <FakeRePop />
    case PopType.AiPop:
      return <AIPop />
    case PopType.AiRePop:
      return <AIRepopForm isEdit={isEdit} />
    case PopType.ActionPop:
      return <ActionPopForm />
    default:
      return null
  }
}
